import { render, staticRenderFns } from "./FinalizedFnrhModal.vue?vue&type=template&id=20edd0d6&"
import script from "./FinalizedFnrhModal.vue?vue&type=script&lang=js&"
export * from "./FinalizedFnrhModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports